import {
  PERFORM_REQUEST,
  PERFORM_REQUEST_FAILURE,
  PERFORM_REQUEST_SUCCESS,
  SET_SEARCH_QUERY,
  SET_PAGE,
  INIT_TRANSLATIONS,
  INIT_LANGUAGE,
  RESET_RESULTS,
} from './actions.mjs';

const initialState = {
  query: '',
  translations: {},
  loading: false,
  error: false,
  page: 1,
  language: null,
  results: {
    total: 0,
    hits: [],
  },
};

const searchPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_QUERY:
      return Object.assign({}, state, {
        query: action.query,
      });
    case SET_PAGE:
      return Object.assign({}, state, {
        page: action.page,
      });
    case INIT_LANGUAGE:
      return Object.assign({}, state, {
        language: action.language,
      });
    case INIT_TRANSLATIONS:
      return Object.assign({}, state, {
        translations: action.translations,
      });
    case PERFORM_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
      });
    case PERFORM_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        results: action.data,
        loading: false,
        error: false,
      });
    case PERFORM_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
      });
    case RESET_RESULTS:
      return Object.assign({}, state, {
        results: {
          total: 0,
          hits: [],
        },
      });
    default:
      return state;
  }
};

export default searchPageReducer;
